import _ from 'lodash';
import * as ActionTypes from '../actions/catalogActions';

export const catalog = (
  state = {
    industries: [],
    industriesById: {},
    departmentsById: {},
    categoriesById: {},
    lastFetchedAt: null
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.SYNC_HIERARCHY_SUCCESS:
      const allDepartments = _.flatten(_.map(action.industries, 'departments'));
      const allCategories = _.flatten(_.map(allDepartments, 'categories'));
      return {
        ...state,
        industries: action.industries,
        brands: action.brands,
        lastFetchedAt: action.lastFetchedAt,

        // Used to make performance improvements
        industriesById: _.keyBy(action.industries, 'id'),
        departmentsById: _.keyBy(allDepartments, 'id'),
        categoriesById: _.keyBy(allCategories, 'id')
      };

    default:
      return state;
  }
};
